import React, { ReactElement } from 'react'
import styles from './index.module.scss'
import emptyImg from '../../assets/images/noResults.png'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
interface Iprops {
  detail?: string
  children: ReactElement
  className?: string
  onLoadImg?: () => void
}
export const DataEmpty = ({ detail, children, className, onLoadImg }: Iprops) => {
  const {t} = useTranslation()
  return (
    <div className={clsx(styles.empty__wrap, className)}>
      <div className={styles.empty}>
        <img onLoad={onLoadImg} src={emptyImg} alt="" />
        <h2>{t('common.noResultsFound')}</h2>
        <p>{detail}</p>
      </div>
      {children}
    </div>
  )
}
